<div id="configuration-container">
  <div class="configuration-header">
    <div class="back-button" (click)="moveBack()" *ngIf="!isSuccessfullySubmitted && !noWayBack">
      <nb-icon icon="arrow-left" pack="icomoon"></nb-icon>
    </div>
    <div class="campaign-name">
      <h4 class="modal-name">{{ currentCampaign?.name }}</h4>
    </div>
  </div>
  <app-configuration-created-header
    [selectedConfigData]="selectedConfigData"
    [currentCampaignName]="currentCampaign?.name ?? ''"
    [component]="component"
    [step]="isSuccessfullySubmitted ? 2 : 1 ">
  </app-configuration-created-header>

  <div class="created-info-container" *ngIf="isSuccessfullySubmitted">
    <h3>{{ configurationInfoTitle }}</h3>
    <h4>{{ 'view_translations.banner_copy_info' | translate }}</h4>
  </div>
  <div class="configuration-selection-container">
    <app-configuration-selection
      [currentCampaign]="currentCampaign"
      [submitted]="submitted"
      (emitConfig)="getPickedConfig($event)"></app-configuration-selection>
  </div>
  <app-loader *ngIf="modalLoading; else inputsContent"></app-loader>
  <ng-template #inputsContent>
    <app-select-container
      *ngIf="selectData.data.length"
      [data]="selectData.data"
      [title]="selectData.title"
      [submitted]="submitted"
      [shouldTranslate]="false"
      (emitValue)="getSelectedValue($event)"
      [idOfDefaultValue]="idOfDefaultValue"
      [borderWidth]="2"
      [borderRadius]="10">
    </app-select-container>
  </ng-template>
  <!--  <app-select-input-->
  <!--    [fieldInfo]="trackingDomains"-->
  <!--    (emitValue)="getValue($event)"-->
  <!--    [defaultValue]="defaultTrackingDomainValue"-->
  <!--    [submitted]="submitted">-->
  <!--  </app-select-input>-->
  <div class="information-link">
    <a href="#">{{ 'view_translations.how_choose_tracking_domain' | translate }}</a>
  </div>
  <div class="generated-code-container" *ngIf="isSuccessfullySubmitted && isBannerComponent">
    <app-banner-code [bannerConfigurationData]="configurationData"></app-banner-code>
  </div>
  <div class="generated-url-container" *ngIf="isSuccessfullySubmitted && !isBannerComponent">
    <app-product-generated-url [productConfigurationData]="configurationData"></app-product-generated-url>
  </div>
</div>
<div class="btn-container" id="addConfigButton">
  <app-primary-button
    [buttonText]="isSuccessfullySubmitted ? 'back_to_configuration_list' : ( isBannerComponent ? 'generate_code' : 'generate_link')"
    [icon]="isSuccessfullySubmitted ? '' : 'code'"
    [iconSize]="14"
    [background]="'orange'"
    (emitAction)="actionButton()">
  </app-primary-button>
</div>
